var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { ModalService } from "../../views/modal/base_modal.component";
import { ErrorsDetailsComponent } from "./details/errors_details.component";
import { DateFormat } from "../../pipes/dateFormat.pipe";
import { ChartParams } from "../../views/chart/chart.component";
import { BillingService2 } from "../billing.service";
import { mergeFilterParams } from "../../lib/lib";
var ErrorsComponent = /** @class */ (function (_super) {
    __extends(ErrorsComponent, _super);
    function ErrorsComponent(service2, activatedRoute, translate, filter, eventsService, modalService, dateFormat) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.service2 = service2;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.modalService = modalService;
        _this.dateFormat = dateFormat;
        _this.rows = [];
        _this.items = [];
        _this.listLoader = false;
        _this.page = 1;
        _this.pageSize = 100;
        _this.paidErrorChart = new ChartParams();
        _this.processingFilterChart = new ChartParams();
        _this.noMoneyOrExpirerChart = new ChartParams();
        _this.rejectEmitterChart = new ChartParams();
        _this.error3dsChart = new ChartParams();
        _this.unknownChart = new ChartParams();
        _this.notClassifiedChart = new ChartParams();
        _this.errSiteUserManualRecurentChart = new ChartParams();
        _this.invalidCardDataChart = new ChartParams();
        _this.paidErrorChart.setOptions({
            title: 'График ошибок',
            names: {
                'processingFilter': _this.translate.__A('billing.errors.processingFilter'),
                'noMoneyOrExpirer': _this.translate.__A('billing.errors.noMoneyOrExpirer'),
                'rejectEmitter': _this.translate.__A('billing.errors.rejectEmitter'),
                'error3ds': _this.translate.__A('billing.errors.error3ds'),
                'unknown': _this.translate.__A('billing.errors.unknown'),
                'notClassified': _this.translate.__A('billing.errors.notClassified'),
                'invalidCardData': _this.translate.__A('billing.errors.invalidCardData'),
            },
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        _this.processingFilterChart.setOptions({
            title: _this.translate.__A('billing.errors.processingFilter'),
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        _this.noMoneyOrExpirerChart.setOptions({
            title: _this.translate.__A('billing.errors.noMoneyOrExpirer'),
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        _this.rejectEmitterChart.setOptions({
            title: _this.translate.__A('billing.errors.rejectEmitter'),
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        _this.error3dsChart.setOptions({
            title: _this.translate.__A('billing.errors.error3ds'),
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        _this.unknownChart.setOptions({
            title: _this.translate.__A('billing.errors.unknown'),
            names: {
                'UNKNOWN_ERROR': _this.translate.__A('billing.errors.UNKNOWN_ERROR')
            },
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        _this.notClassifiedChart.setOptions({
            title: 'Неклассифицированные ошибки',
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        _this.errSiteUserManualRecurentChart.setOptions({
            title: 'Пользователи и Сайты',
            axes: {
                userCountRecurent: 'y',
                siteCountRecurent: 'y',
                userCountManual: 'y2',
                siteCountManual: 'y2',
            },
            axis: {
                y: {
                    label: {
                        text: 'Рекурентные',
                        position: 'outer-middle'
                    }
                },
                y2: {
                    show: true,
                    label: {
                        text: 'Ручные',
                        position: 'outer-middle'
                    }
                }
            }
        });
        _this.invalidCardDataChart.setOptions({
            title: 'Неверные данные карты',
            axis: {
                y: {
                    label: {
                        text: 'Пользователи',
                        position: 'outer-middle'
                    }
                },
            }
        });
        return _this;
    }
    ErrorsComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPaidErrorChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getList()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ErrorsComponent.prototype.getList = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.listLoader = true;
                        return [4 /*yield*/, this.service2.error.stats(mergeFilterParams(this.filter.filterParams, params)).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.items = stats;
                        this.listLoader = false;
                        return [4 /*yield*/, this.getPage()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ErrorsComponent.prototype.getPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var s, e;
            return __generator(this, function (_a) {
                s = (this.page - 1) * this.pageSize;
                e = s + this.pageSize;
                this.rows = this.items.slice(s, e);
                return [2 /*return*/];
            });
        });
    };
    ErrorsComponent.prototype.showDetails = function (timestamp, type) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalRef = this.modalService.open(ErrorsDetailsComponent, {
                            title: this.dateFormat.transform(timestamp, 'DD.MM.YYYY'),
                            type: type
                        }, { size: type === 'sites' ? 'hg' : 'lg' });
                        return [4 /*yield*/, this.service2.error.detail(mergeFilterParams(this.filter.filterParams, { timestamp: timestamp, type: type })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        return [2 /*return*/];
                }
            });
        });
    };
    ErrorsComponent.prototype.getPaidErrorChart = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var me, chartSubTypes, _i, chartSubTypes_1, chartSubType, chart, fp, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (me.dontLoad.paidChart) {
                            return [2 /*return*/, true];
                        }
                        chartSubTypes = [
                            'paidError', 'error3ds', 'processingFilter',
                            'noMoneyOrExpirer', 'rejectEmitter', 'unknown',
                            'notClassified', 'errSiteUserManualRecurent', 'invalidCardData',
                        ];
                        _i = 0, chartSubTypes_1 = chartSubTypes;
                        _a.label = 1;
                    case 1:
                        if (!(_i < chartSubTypes_1.length)) return [3 /*break*/, 4];
                        chartSubType = chartSubTypes_1[_i];
                        chart = me[chartSubType + "Chart"];
                        fp = mergeFilterParams(this.filter.filterParams, params, chartSubType === 'paidError' ? {} : { chartSubType: chartSubType, });
                        chart.showLoader();
                        return [4 /*yield*/, me.service2.error.chart(fp).toPromise()];
                    case 2:
                        charts = (_a.sent()).charts;
                        chart.data = charts;
                        chart.hideLoader();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ErrorsComponent;
}(BaseComponent));
export { ErrorsComponent };
